var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBackArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID 1536",
    d: "M15.6053 5.99997C15.6053 6.43997 15.2453 6.79997 14.8053 6.79997H3.12527L6.74528 10.44C7.06528 10.76 7.06528 11.26 6.74528 11.58C6.58528 11.74 6.38527 11.82 6.18527 11.82C5.98527 11.82 5.76527 11.74 5.62527 11.58L0.645276 6.57997C0.325276 6.25997 0.325276 5.75997 0.645276 5.45997L5.62527 0.459968C5.94527 0.139968 6.44527 0.139968 6.76527 0.459968C7.08527 0.779968 7.08527 1.27997 6.76527 1.59997L3.12527 5.19997H14.8053C15.2453 5.19997 15.6053 5.55997 15.6053 5.99997Z",
    fill: "#F5D016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBackArrowIcon);
export default __webpack_public_path__ + "static/media/new_back_arrow_icon.5292b4aaebdb767b8d503dd6ff36d71e.svg";
export { ForwardRef as ReactComponent };